import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="https://static.readdy.ai/image/db57219f15db34a21692ac78f577b434/46f6736fef32c51eeedc8d15503658d2.jpeg"
            alt="Lam Lam Wholesale Company Logo"
            className="h-24 w-24 object-contain rounded-full"
          />
        </div>

        {/* 社交媒体 */}
        <div className="flex justify-center space-x-6 mb-8">
          <a
            href="https://www.facebook.com/profile.php?id=100075469556578"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
            aria-label="Facebook"
          >
            <i className="ri-facebook-fill text-xl"></i>
          </a>
          <a
            href="https://www.instagram.com/jc.kidss/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors cursor-pointer"
            aria-label="Instagram"
          >
            <i className="ri-instagram-line text-xl"></i>
          </a>
        </div>

        {/* 底部链接 */}
        <div className="text-center text-sm text-gray-400 space-y-2">
          <p>© 2026, Lam Lam Wholesale</p>
        </div>
      </div>
    </footer>
  );
}
